
import { ArticleData } from "@planetadeleste/vue-mc-goodnews";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class TestimonialItem extends Vue {
  @Prop(Object) readonly item!: ArticleData;
}
